/**
 * @generated SignedSource<<8e87f93fea55ec2e4a52297e5af0dbc9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useOrganizationDetailRelayQuery$variables = {
  id: string;
};
export type useOrganizationDetailRelayQuery$data = {
  readonly getOrganization: {
    readonly hasBrandedApp: boolean | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly parent: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type useOrganizationDetailRelayQuery = {
  response: useOrganizationDetailRelayQuery$data;
  variables: useOrganizationDetailRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "getOrganization",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasBrandedApp",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useOrganizationDetailRelayQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOrganizationDetailRelayQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "c865cf6f740d313722efff162f6e8eb0",
    "id": null,
    "metadata": {},
    "name": "useOrganizationDetailRelayQuery",
    "operationKind": "query",
    "text": "query useOrganizationDetailRelayQuery(\n  $id: ID!\n) {\n  getOrganization(id: $id) {\n    id\n    name\n    hasBrandedApp\n    parent {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "214e52b01d5699bf9e80ce84a7de2c58";

export default node;
